import React, { FC, useState } from 'react'
import { IonFooter, IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { cartMobx, orderMobx, restaurantConfig, restaurantCenter } from 'restaurant'
import { buyTogetherMobx } from '@mobxStore'
import { RestoreOrderController, CheckoutPayController } from '@ctrls/index'
import { store, getCookie, setCookie } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps extends RouteComponentProps {}

const Payfail: FC<IProps> = ({ match }) => {
  // const isBuyTogether = !!Config.buyTogetherId
  const buyTogetherId = Config.buyTogetherId || getCookie(`buyTogetherId.${Config.BRANDID}`)
  const isBuyTogether = !!buyTogetherId
  const history = useHistoryNew()
  const { id } = match.params as any
  const [reason, setReason] = useState('')
  const [fromOrderList, setFromOrderList] = useState(false)

  if (!Config.buyTogetherId && buyTogetherId) {
    Config.buyTogetherId = buyTogetherId
    restaurantCenter.setConfig({
      ...restaurantConfig,
      buyTogetherId
    })
  }

  // 取消订单
  const cancelOrder = () => {
    orderMobx.reset()
    cartMobx.clearOrdersId()
    cartMobx.setOrdersPreId()
    orderMobx.cancel(false)
  }

  const handleCancel = async () => {
    const brandId = restaurantConfig.brandId || Config.BRANDID || orderMobx.order.brandId
    const storeId = restaurantConfig.storeId || Config.STOREID || orderMobx.order.storeId
    store.remove(`${RestoreOrderController.localKey('prefix')}.${brandId}.${storeId}`)
    cartMobx.reset(cartMobx.info.payMode, cartMobx.info.eatType)
    if (isBuyTogether) {
      await orderMobx.cancel()
      setCookie(`buyTogetherId.${Config.BRANDID}`, '', 3 * 60 * 1000)
      buyTogetherMobx.delStorage()
      location.href = `/menu?ct=brand&b=${Config.BRANDID}&s=${storeId}`
    } else {
      !cartMobx.info.payMode && orderMobx.cancel()
      history.replace('/menu')
    }
  }

  const handleRepay = async () => {
    if (isBuyTogether) {
      history.replace('/buyTogetherCart')
    } else {
      if (!cartMobx.info.payMode) {
        cancelOrder()
      }
      history.replace('/checkout')
    }
  }

  useIonViewWillEnter(() => {
    const state: any = history.location.state
    setFromOrderList(history.getPrevState() === '/orders')
    setReason(state && state.reason ? state.reason : fromOrderList ? i18n.t('pay.payUnfinished') : i18n.t('pay.failedMessage'))
    if (id) {
      restaurantCenter.init()
    }
    let _id = RestoreOrderController.getTempHold() || id
    if (orderMobx.order.ordersId || _id) {
      CheckoutPayController.resume(orderMobx.order.ordersId || _id).finally(() => {
        if (orderMobx.order.ordersId) {
          cartMobx.setOrdersId(orderMobx.order.ordersId)
        }
        if (_id) {
          const brandId = restaurantConfig.brandId || Config.BRANDID || orderMobx.order.brandId
          const storeId = restaurantConfig.storeId || Config.STOREID || orderMobx.order.storeId
          store.set(`${RestoreOrderController.localKey('prefix')}.${brandId}.${storeId}`, _id)
          RestoreOrderController.restore(true)
        }
      })
    }
  })
  return (
    <IonPage className='pay-fail-page'>
      <IonContent>
        <i className='iconfont icon-warning-circle' />
        <h4>{i18n.t('pageName.payfail')}</h4>
        <h6>{reason}</h6>
      </IonContent>
      <IonFooter>
        <div className='handle-btn'>
          <div className='repay' onClick={handleRepay}>{i18n.t('payfail.repay')}</div>
          <div className='reproduct' onClick={handleCancel}>{i18n.t('order.cancelOrder')}</div>
        </div>
      </IonFooter>
    </IonPage>
  )
}
export default Payfail
